import { render, staticRenderFns } from "./ModalSurveyAccordance.vue?vue&type=template&id=65652282&scoped=true"
import script from "./ModalSurveyAccordance.vue?vue&type=script&lang=js"
export * from "./ModalSurveyAccordance.vue?vue&type=script&lang=js"
import style0 from "./ModalSurveyAccordance.vue?vue&type=style&index=0&id=65652282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65652282",
  null
  
)

export default component.exports